import { z } from "zod";

import { fetchWithThrow } from "@rosette/web_utils/src/fetchWithThrow.js";
import type { AchievementType } from "@rosette/ts/src/business/achievement/AchievementType.js";
import { APIEarnedAchievement } from "@rosette/ts/src/business/api/api_schema.js";


export const RequestAchievementRequest = z.object({
    achievementID: z.string(),
});
export type RequestAchievementRequest = z.infer<typeof RequestAchievementRequest>;

export const RequestAchievementResponse = z.object({
    earnedAchievements: z.array(APIEarnedAchievement),
});
export type RequestAchievementResponse = z.infer<typeof RequestAchievementResponse>;

export async function requestAchievement(achievement: AchievementType): Promise<RequestAchievementResponse> {
    const request: RequestAchievementRequest = { achievementID: achievement.getID() };
    const response = await fetchWithThrow("/api/requestAchievement", {
        method: "POST",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
    });
    return RequestAchievementResponse.parse(await response.json());
}
